module.exports = __webpack_public_path__ + "static/highlight-pattern-08e5ac291915362a563a040ce619ee83.svg";